import React, { useState } from "react";
import { Modal } from "../Modal/Modal";
import { Form, Label, Input, ButtonContainer } from "./styles";
import Button from "../Button/button";
import {
  BlueTitle,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  StyledHR,
} from "../../shared/styles/global.styles";
import { IoCloseSharp } from "react-icons/io5";

interface FiltroDataModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (dataInicio: string, dataFinal: string) => void;
}

const FiltroDataModal: React.FC<FiltroDataModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");

  const formatarDataParaAPI = (
    dataStr: string,
    isFinal: boolean = false
  ): string => {
    if (!dataStr) return "";

    try {
      // Mantém o formato YYYY-MM-DD
      const data = dataStr.split("T")[0];
      return data;
    } catch (error) {
      console.error("Erro ao formatar data:", error);
      return "";
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!dataInicio || !dataFinal) {
      console.error("Datas não preenchidas");
      return;
    }

    const dataInicioFormatada = formatarDataParaAPI(dataInicio);
    const dataFinalFormatada = formatarDataParaAPI(dataFinal);

    if (!dataInicioFormatada || !dataFinalFormatada) {
      console.error("Erro ao formatar datas");
      return;
    }

    // Validação adicional das datas
    const dataInicioObj = new Date(dataInicioFormatada);
    const dataFinalObj = new Date(dataFinalFormatada);

    if (dataInicioObj > dataFinalObj) {
      alert("A data inicial não pode ser maior que a data final");
      return;
    }

    onConfirm(dataInicioFormatada, dataFinalFormatada);
    setDataInicio("");
    setDataFinal("");
    onClose();
  };

  const handleDateChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    setDate?: (value: string) => void
  ) => {
    let value = event.target.value;

    // Captura o ano digitado
    const parts = value.split("-");
    if (parts.length === 3) {
      let year = parts[0];

      // Limita o ano a 4 dígitos
      if (year.length > 4) {
        year = year.substring(0, 4); // Mantém apenas os primeiros 4 dígitos
      }

      // Monta a nova data corrigida
      value = `${year}-${parts[1]}-${parts[2]}`;
    }

    if (setDate) {
      setDate(value);
    }
  };

  return (
    <ModalContainer show={isOpen}>
      <ModalContent>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => onClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>Filtrar por Data</BlueTitle>
        </ModalHeader>
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <Label>
              Data início:
              <Input
                type="date"
                value={dataInicio}
                onChange={(e) => handleDateChange(e, setDataInicio)}
                required
              />
            </Label>

            <Label>
              Data final:
              <Input
                type="date"
                value={dataFinal}
                onChange={(e) => handleDateChange(e, setDataFinal)}
                required
              />
            </Label>
          </ModalBody>
          <ModalFooter>
            <Button type="button" action={onClose} schemaButton="out-primary">
              Cancelar
            </Button>
            <Button type="submit" schemaButton="full-primary">
              Confirmar
            </Button>
          </ModalFooter>
        </Form>
      </ModalContent>
    </ModalContainer>
  );
};

export default FiltroDataModal;
